import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BasketTotalsComponentDef } from '@df/basket/view/basket-totals.component.def';
import { Status } from '@df/core/status';
import { PriceComponent } from '@df/ui/price/price.component';
import { TaxMode } from '@df/ui/price/price.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { InlineButtonComponent } from '../../../common/buttons/inline-button/inline-button.component';

@Component({
    selector: 'basket-view-totals',
    templateUrl: 'basket-view-totals.html',
    imports: [PriceComponent, TranslationModule, InlineButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketViewTotalsComponent extends BasketTotalsComponentDef {
    @Input()
    onlyTotal = false;

    removeStatus = new Status();

    protected override getTotalLabel(): string {
        return this.withShipping ? 'Order total' : 'Order total (excl. delivery)';
    }

    override removeCoupon(): Promise<any> {
        if (!this.coupon) {
            return Promise.resolve();
        }
        return this.app.customer.basket.removeCoupon(this.removeStatus, {
            coupon: this.coupon
        });
    }

    get coupon(): string | string[] | undefined {
        return this.app.customer.basket.data.coupon;
    }

    protected override getDiscountLabel(taxMode?: TaxMode): string {
        return 'Promo code';
    }
}
